import http from './http.js';

//保存评论
export function submitFarmComment(farm_id,param){
    return http.post(`/user/farm/save_farm_comment/`+farm_id,param)
}

//获取评论
export function getFarmCommentList(farm_id,param){
    return http.get(`/user/farm/get_farm_comment_list/`+farm_id,param)
}

export function setFarmCommentZan(id){
    return http.post(`/user/farm/set_farm_comment_zan/`+id)
}
